
import { defineComponent, ref, onMounted, computed } from 'vue'
import { updateName } from '@/api/profile'
import { ElMessage } from 'element-plus'
import Upload from '@/components/profile/upload.vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    userInfoList: {
      type: Object,
      default: () => ({}),
    },
    userName: {
      type: String,
      default: '',
    },
  },

  components: { Upload },
  setup(props, { emit }) {
    const { t } = useI18n()
    const isEdit = ref(false)
    const showName = computed(() => props.userName)
    const personal = computed(() => props.userInfoList)
    const inputName = ref<string>('')
    const radio = ref<string>('')
    const birthDate = ref<string>('')
    const updateNameRef = ref<HTMLInputElement>()
    const options = [
      {
        value: '0',
        label: t('profile.year50s'),
      },
      {
        value: '1',
        label: t('profile.year60s'),
      },
      {
        value: '2',
        label: t('profile.year70s'),
      },
      {
        value: '3',
        label: t('profile.year80s'),
      },
      {
        value: '4',
        label: t('profile.year85s'),
      },
      {
        value: '5',
        label: t('profile.year90s'),
      },
      {
        value: '6',
        label: t('profile.year95s'),
      },
      {
        value: '7',
        label: t('profile.year00s'),
      },
      {
        value: '8',
        label: t('profile.year05s'),
      },
    ]
    const edit = () => {
      isEdit.value = true
      inputName.value = showName.value
      setTimeout(() => {
        // autofocus并不是每次都有效，只有第一次有效，后面不能autofocus，所以手动focus
        updateNameRef.value?.focus()
      }, 200)
    }

    const nameChange = async () => {
      if (inputName.value === showName.value) {
        isEdit.value = false
        return
      }
      if (inputName.value && personal.value.userName.length <= 255) {
        const res = await updateName(inputName.value)
        if (res.status) {
          ElMessage({
            message: t('profile.updateSuccess'),
            type: 'success',
          })
          emit('uploadSuccess')
        }
      }
      isEdit.value = false
    }

    const genderChange = () => {
      personal.value.gender = parseInt(radio.value)
    }
    const birthChange = () => {
      bitrhTrasnfer(parseInt(birthDate.value))
    }
    const bitrhTrasnfer = (value: number) => {
      switch (value) {
        case 0:
          birthDate.value = '0'
          personal.value.ageClass = 0
          break
        case 1:
          birthDate.value = '1'
          personal.value.ageClass = 1
          break
        case 2:
          birthDate.value = '2'
          personal.value.ageClass = 2
          break
        case 3:
          birthDate.value = '3'
          personal.value.ageClass = 3
          break
        case 4:
          birthDate.value = '4'
          personal.value.ageClass = 4
          break
        case 5:
          birthDate.value = '5'
          personal.value.ageClass = 5
          break
        case 6:
          birthDate.value = '6'
          personal.value.ageClass = 6
          break
        case 7:
          birthDate.value = '7'
          personal.value.ageClass = 7
          break
        case 8:
          birthDate.value = '8'
          personal.value.ageClass = 8
          break
        default:
          birthDate.value = ''
          personal.value.ageClass = null
      }
    }
    const uploadSuccess = () => {
      emit('uploadSuccess')
    }

    onMounted(() => {
      radio.value = `${personal.value.gender}`
      bitrhTrasnfer(personal.value.ageClass)
    })
    return {
      isEdit,
      edit,
      radio,
      birthDate,
      options,
      genderChange,
      birthChange,
      nameChange,
      uploadSuccess,
      updateNameRef,
      showName,
      inputName,
      personal,
    }
  },
})
